import axios from 'axios';
import { env } from '../../_settings/env';

const axiosClient = axios.create({
  baseURL: env.REACT_APP_BACKEND_URL,
});
axiosClient.interceptors.request.use((config ) => {
  const token = localStorage.getItem('admissao.auth.token');

  config.headers = config.headers ?? {};
  config.headers['Authorization'] = token ? `Bearer ${token}` : '';
  return config;
}, (error) => {
  return Promise.reject(error);
});


export default axiosClient;
